import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'

export default function DayNightToggle({ checked, onChange, label }) {
	return (
		<button
			type="button"
			role="switch"
			aria-checked={checked}
			aria-label={label}
			onClick={onChange}
			className="flex h-11 items-center rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
		>
			<span
				aria-hidden="true"
				className={`flex h-8 w-16 items-center rounded-full p-1 ${
					checked ? 'bg-gray-700' : 'bg-primary'
				}`}
			>
				<span
					className={`flex h-6 w-6 items-center justify-center rounded-full bg-white text-gray-700 transition-transform duration-200 motion-reduce:transition-none ${
						checked ? 'translate-x-8' : 'translate-x-0'
					}`}
				>
					<FontAwesomeIcon icon={checked ? faMoon : faSun} />
				</span>
			</span>
		</button>
	)
}
